import React from 'react'

import './terminal.css';
import './fonts/Terminal.woff';
import Box from './Components/box.jsx';
import download from './Assets/download.svg'
import { useState, useEffect } from 'react';

const Download = ({mainBoxHeight, mainBoxWidth}) => {

	const textStyle = {color:"white", margin:0, marginBottom:"15px", fontFamily: "Terminal", fontSize:40, letterSpacing:"3px", opacity:0.9, textAlign:"center"}

	useEffect(() => {
		document.title = 'Killing Machine Movement - Download';
	}, []);

	const [isHover, setHover] = useState(false)
	const [isHover2, setHover2] = useState(false)
	const [isHover3, setHover3] = useState(false)
	const [isHover4, setHover4] = useState(false)

	return <Box height={mainBoxHeight-160} width={mainBoxWidth-60} down={100} style={{paddingTop:20}}>
		<a href={"/games/MovementInstaller.exe"} download>
		    <div onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
			    <Box opacity={isHover ? 0.6 : 0.3} fill="red" height={(mainBoxHeight-160-80)/2} width={mainBoxWidth-60-70} down={(mainBoxHeight-160-80)/4-200} style={{paddingTop:5}} corner={0}>
			      <div style={{color:"white", margin:0, marginBottom:"15px", fontFamily: "Terminal", fontSize:80, letterSpacing:"3px", opacity:0.9}}>
			        <p>DOWNLOAD<img src={download} alt={"download"} style={{paddingLeft: "40px"}}/></p>
			        <p style={{fontSize:20}}>LATEST VERSION v1.1.1</p>
			        <p style={{fontSize:20}}>Installer exe (recommended)</p>
			      </div>
			    </Box>
		    </div>
	    </a>
	    <a href={"/games/Movement.zip"} download>
		    <div onMouseEnter={() => setHover2(true)} onMouseLeave={() => setHover2(false)}>
			    <Box opacity={isHover2 ? 0.6 : 0.3} fill="red" height={(mainBoxHeight-160-80)/4} width={mainBoxWidth-60-70} down={(mainBoxHeight-160-80)/2+(mainBoxHeight-160-80)/6.7-160} style={{paddingTop:10}} corner={0}>
			      <div style={{color:"white", margin:0, marginBottom:"15px", fontFamily: "Terminal", fontSize:50, letterSpacing:"3px", opacity:0.9}}>
			        <p>DOWNLOAD<img src={download} alt={"download"} style={{paddingLeft: "40px"}}/></p>
			        <p style={{fontSize:20, marginTop:"-30px"}}>LATEST VERSION v1.1.1</p>
			        <p style={{fontSize:20}}>Zip Archive (portable)</p>
			      </div>
			    </Box>
		    </div>
	    </a>
	    <a href={"/games/MovementInstaller100.exe"} download>
		    <div onMouseEnter={() => setHover3(true)} onMouseLeave={() => setHover3(false)}>
			    <Box opacity={isHover3 ? 0.5 : 0.15} fill="red" height={(mainBoxHeight-160-80)/8} width={mainBoxWidth-60-70} down={(mainBoxHeight-160-80)/2+(mainBoxHeight-160-80)/4+60+(mainBoxHeight-160-80)/16-50} style={{paddingTop:15}} corner={0}>
			      <div style={{color:"white", margin:0, marginBottom:"15px", fontFamily: "Terminal", fontSize:50, letterSpacing:"3px", opacity:0.9}}>
			        <p style={{fontSize:20, marginTop:"-30px"}}>OLD VERSION v1.0.0</p>
			        <p style={{fontSize:20}}>Installer exe</p>
			      </div>
			    </Box>
		    </div>
	    </a>
	    <a href={"/games/Movement100.zip"} download>
		    <div onMouseEnter={() => setHover4(true)} onMouseLeave={() => setHover4(false)}>
			    <Box opacity={isHover4 ? 0.5 : 0.15} fill="red" height={(mainBoxHeight-160-80)/8-20} width={mainBoxWidth-60-70} down={(mainBoxHeight-160-80)/8+ (mainBoxHeight-160-80)/2+(mainBoxHeight-160-80)/4+(mainBoxHeight-160-80)/16+10} style={{paddingTop:15}}>
			      <div style={{color:"white", margin:0, marginBottom:"15px", fontFamily: "Terminal", fontSize:50, letterSpacing:"3px", opacity:0.9}}>
			        <p style={{fontSize:20, marginTop:"-30px"}}>OLD VERSION v1.0.0</p>
			        <p style={{fontSize:20}}>Zip Archive (portable)</p>
			      </div>
			    </Box>
		    </div>
	    </a>


		{/*<a href={"/games/MovementInstaller100.exe"} download>
		    <div onMouseEnter={() => setHover3(true)} onMouseLeave={() => setHover3(false)}>
			    <Box opacity={isHover3 ? 0.6 : 0.3} fill="red" height={(mainBoxHeight-160-80)/6} width={mainBoxWidth-60-70} down={(mainBoxHeight-160-80)/4-200} style={{paddingTop:10}} corner={0}>
			      <div style={{color:"white", margin:0, marginBottom:"15px", fontFamily: "Terminal", fontSize:80, letterSpacing:"3px", opacity:0.9}}>
			        <p>DOWNLOAD<img src={download} alt={"download"} style={{paddingLeft: "40px"}}/></p>
			        <p style={{fontSize:20}}>LATEST VERSION v1.0.0</p>
			        <p style={{fontSize:20}}>Installer exe</p>
			      </div>
			    </Box>
		    </div>
	    </a>
	    <a href={"/games/Movement100.zip"} download>
		    <div onMouseEnter={() => setHover4(true)} onMouseLeave={() => setHover4(false)}>
			    <Box opacity={isHover4 ? 0.6 : 0.3} fill="red" height={(mainBoxHeight-160-80)/6} width={mainBoxWidth-60-70} down={(mainBoxHeight-160-80)/2+(mainBoxHeight-160-80)/4-200} style={{paddingTop:10}}>
			      <div style={{color:"white", margin:0, marginBottom:"15px", fontFamily: "Terminal", fontSize:80, letterSpacing:"3px", opacity:0.9}}>
			        <p>DOWNLOAD<img src={download} alt={"download"} style={{paddingLeft: "40px"}}/></p>
			        <p style={{fontSize:20}}>LATEST VERSION v1.0.0</p>
			        <p style={{fontSize:20}}>Zip Archive (portable)</p>
			      </div>
			    </Box>
		    </div>
	    </a>*/}
	    	   {/* <a href={"/games/Movement.zip"} download>
		    <div onMouseEnter={() => setHover2(true)} onMouseLeave={() => setHover2(false)}>
			    <Box opacity={isHover2 ? 0.6 : 0.3} fill="red" height={(mainBoxHeight-160-80)} width={mainBoxWidth-60-70} down={(mainBoxHeight-160-80)/2-200} style={{paddingTop:10}}>
			      <div style={{color:"white", margin:0, marginBottom:"15px", fontFamily: "Terminal", fontSize:80, letterSpacing:"3px", opacity:0.9}}>
			        <p>DOWNLOAD<img src={download} alt={"download"} style={{paddingLeft: "40px"}}/></p>
			        <p style={{fontSize:20}}>LATEST VERSION v1.0.0</p>
			        <p style={{fontSize:20}}>Zip Archive</p>
			      </div>
			    </Box>
		    </div>
	    </a>*/}
	  </Box>

}

export default Download